import { ZOOM } from "../../actions/portal/";

export default function(state = 5, action){
  switch (action.type) {
    case ZOOM:
    return action.payload;
    default:
  }

  return state;
}
